import { useEffect } from "react";
import Loading from "../components/UI/Loading";
import { useDispatch, useSelector } from "react-redux";
import { StartOnboarding } from "../store/sign-store/sign-actions";
import { useParams } from "react-router-dom";

let once = true;

const Waitingroom = () => {
  const onboardingUrl = useSelector((state) => state.sign.onboardingStartUr);
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    if ((onboardingUrl === undefined || onboardingUrl === "") && once) {
      dispatch(StartOnboarding(params.pk, "email@email.com"));
      once = false;
    }
  }, [dispatch, onboardingUrl, params.pk]);
   

  useEffect(() => {
    if (onboardingUrl !== undefined && onboardingUrl !== "") {
        window.location.replace(onboardingUrl.instanceUrl)
    }
  }, [onboardingUrl]);

  return <Loading visible={true} />;
};
export default Waitingroom;
